(function () {
    'use strict';

    var module = angular.module('uwAgenda.tasks');
    // directive for showing task-flags
    module.directive('taskFlags', ['FlagTypeEnum', function (FlagTypeEnum) {
        var directive = {
            link: link,
            restrict: 'E',
            templateUrl: '/app/tasks/templates/task-flags.template.html',
            scope: {
                model: '=',
                change: '='
            }
        };
        return directive;

        function link(scope) {
            // flags
            scope.flags = [];
            // watcher
            var watcher = null;

            activate();

            // select flag
            scope.select = function (flag) {
                // unselect ?
                if (flag.selected) {
                    scope.model = null; // deselect
                    return;
                }

                // update model
                scope.model = flag.value;

                if (scope.change && typeof scope.change === 'function') {
                    scope.change(flag.value);
                }
            };

            //activate
            function activate() {
                angular.forEach(FlagTypeEnum, function (item) {

                    // new 
                    var flag = {
                        color: item.color,
                        value: item.value,
                        selected: false,
                        name: item.name
                    };

                    // preselect
                    if (scope.model === item.value) { flag.selected = true; }

                    scope.flags.push(flag);
                });

                // watch on model change
                watcher = scope.$watch('model', function (newVal) {
                    scope.flags.forEach(function (item) {
                        // default set to false
                        item.selected = false;
                        // current one found ?
                        if (item.value === newVal) {
                            item.selected = true;
                        } //if
                    });
                });

            } // activate

            // on destroy
            scope.$on("$destroy", function () {
                watcher();
                watcher = null;
            });

        }
    }]);

})();